import { Controller } from "@hotwired/stimulus"

// Connects to data-controller="attendance-form"
export default class extends Controller {
  static targets = ["entryAtField", "exitAtField"]

  pasteCurrentTimeToEntryTimeInput() {
    this.entryAtFieldTarget.value = this.#currentTime()
  }

  pasteCurrentTimeToExitTimeInput() {
    this.exitAtFieldTarget.value = this.#currentTime()
  }

  #currentTime() {
    const now = new Date()
    const hours = String(now.getHours()).padStart(2, '0')
    const minutes = String(now.getMinutes()).padStart(2, '0')

    return `${hours}:${minutes}`
  }
}
